import { render } from "./BaseCardViewDefects.vue?vue&type=template&id=48d9609f"
import script from "./BaseCardViewDefects.vue?vue&type=script&lang=js"
export * from "./BaseCardViewDefects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__